'use client';

import { Checkbox, View } from '@bytel/trilogy-react-ts';

import { PlanType } from '@app-types/product';

export function BlockedProductOption({
    product,
    isOfferBlocked,
    handleCheck,
}: Readonly<{
    product: PlanType;
    isOfferBlocked: boolean;
    handleCheck: () => void;
}>) {
    return (
        <View className='checkboxes-list'>
            <Checkbox
                className='small-label'
                id={`blockedOffer_${product.gencode}`}
                name={`blockedOffer_${product.gencode}`}
                checked={isOfferBlocked}
                onChange={handleCheck}
                label='Forfait bloqué'
            />
        </View>
    );
}
